import { useSelector } from "react-redux";
import { EXERCISE_ROUTE } from "../routes";
import IntroductionView from "../../shared/components/IntroductionView";
import { Navigator } from "../../shared/components/Navigator";
import { RenderLabelText } from "../../shared/components/Button/ButtonLabelText";
import { NavBar } from "../../shared/components/NavBar";
import {
  StyledLoaderCenterContainer,
  StyledLoader,
} from "../../external/EddaXcomp/src/components/CorrectionButton/StyledCorrectionButton";
import { LARGE } from "../../external/EddaXcomp/src/constants";
import {
  StyledLoadingContainer,
  StyledParagraph,
} from "../dashboard/StyledDashboard";
import { selectCurrentProblem } from "../adventurePicker/api/selectors";

const buttonStyles = {
  width: "237px",
  height: "50px",
  boxShadow: "none",
  animationDelay: "4s",
};

export const RecapView = () => {
  const currentProblemRecap = useSelector(selectCurrentProblem)?.data?.recap;
  return (
    <>
      <NavBar position="fixed" />
      {currentProblemRecap && (
        <IntroductionView slides={currentProblemRecap}>
          <Navigator
            route={EXERCISE_ROUTE}
            skin="primary"
            animation="pulse"
            {...buttonStyles}
          >
            <RenderLabelText label="Räkna" />
          </Navigator>
        </IntroductionView>
      )}
      {!currentProblemRecap && (
        <StyledLoadingContainer>
          <StyledParagraph>Laddar innehåll!</StyledParagraph>
          <StyledLoaderCenterContainer>
            <StyledLoader size={LARGE} />
          </StyledLoaderCenterContainer>
        </StyledLoadingContainer>
      )}
    </>
  );
};
